var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.link)?_c('el-link',{attrs:{"underline":false},on:{"click":_vm.toDetail}},[_vm._v(_vm._s(_vm.title))]):_c('span',[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }